import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';

class DictionaryInfo extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/dictionaries/';

		this.state = {
			fetching: true,
			infoVisible: false,
			termCount: 0
		};
	}

	componentDidMount() {
		if (this.props.ordabok) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.props.ordabok != prevProps.ordabok
		) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			ordabok: this.props.ordabok
		});

		fetch(this.url+this.props.ordabok)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					fetching: false
				})
			}.bind(this));

		// Næ í tölu um fjölda hugtaka í orðasafninu
		fetch(config.apiRoot+'/api/index/?limit=0&ordabok='+this.props.ordabok)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					termCount: json.count
				})
			}.bind(this));

		if (this.props.onSearch) {
			this.props.onSearch(this.props.match.params);
		}
	}

	render() {
		return (
			this.state.data && this.state.data.name ?
			<React.Fragment>

				<div className="card info-red-card sticky" style={{top: 102}}>
					<div className="card-body">
						{
							this.state.termCount > 0 &&
							<div className="float-right text-light">
								<small>Fjöldi hugtaka í orðasafni: {this.state.termCount}</small>
							</div>
						}
						<h4 className="card-title"><Link to={'/leit//ordabok/'+this.props.ordabok}>{this.state.data.name}</Link></h4>
						<p className="card-text">
							{
								this.state.data.about &&
							 	<React.Fragment>
									<a className="badge badge-light" href="#" onClick={
										function(event) {
											event.preventDefault();

											this.setState({
												infoVisible: !this.state.infoVisible
											}, function() {
												if (this.state.infoVisible) {
//													window.scrollTo(0, 140);
												}
											}.bind(this));
										}.bind(this)
									}>Nánar um orðasafnið</a>
								</React.Fragment>
							}
							<span className={this.state.data.about ? 'float-right' : ''}>
								{
									this.state.data.email &&
									<React.Fragment><Link className="badge badge-light" to={'/hafa-samband/'+this.props.ordabok}>Tölvupóstur til ritstjórnar</Link></React.Fragment>
								}
							</span>
						</p>
					</div>
				</div>

				{
					this.state.data.about && this.state.data.about.length > 0 &&
					<div className={'dictionary-info'+(this.state.infoVisible ? ' visible' : '')}>
						<p dangerouslySetInnerHTML={{__html: this.state.data.about}} />
					</div>
				}

			</React.Fragment>
			: null
		);
	}
}

export default DictionaryInfo;



// WEBPACK FOOTER //
// ./src/components/DictionaryInfo.js